export const REDUCER_KEY_RESULTS = 'Results';

export const INIT_RESULTS_STATE = 'Results/INIT_RESULTS_STATE';
export const CLEAN_RESULTS_STATE = 'Results/CLEAN_RESULTS_STATE';
export const SET_CHECKED_ITEMS = 'Results/SET_CHECKED_ITEMS';
export const SET_RESULTS_PER_PAGE = 'Results/SET_RESULTS_PER_PAGE';
export const FETCH_RESULTS_ITEMS = 'Results/FETCH_RESULTS_ITEMS';
export const FETCH_RESULTS_ITEMS_SUCCESS = 'Results/FETCH_RESULTS_ITEMS_SUCCESS';
export const FETCH_RESULTS_ITEMS_FAILURE = 'Results/FETCH_RESULTS_ITEMS_FAILURE';
export const ADD_RESULTS_CHUNK = 'Results/ADD_RESULTS_CHUNK';

// Selection
export const SET_ALL_RESULTS_CHECKED = 'Results/SET_ALL_RESULTS_CHECKED';
export const SET_ALL_RESULTS_UNCHECKED = 'Results/SET_ALL_RESULTS_UNCHECKED';
export const SET_RESULT_CHECKED = 'Results/SET_RESULT_CHECKED';
export const SET_PRODUCT_CHECKED = 'Results/SET_PRODUCT_CHECKED';
export const SET_PRODUCTS_CHECKED_FOR_SUBSTANCE = 'Results/SET_PRODUCTS_CHECKED_FOR_SUBSTANCE';

export const genericExportType = 'genericExport';
